import React from 'react';
import { Download, Upload, Sparkles } from 'lucide-react';
interface HeaderProps {
  onUploadClick: () => void;
  onExportClick: () => void;
  hasImage: boolean;
}
export function Header({
  onUploadClick,
  onExportClick,
  hasImage
}: HeaderProps) {
  return <>
      {/* Floating brand pill */}
      <div className="absolute top-4 left-4 z-30 flex items-center gap-2 rounded-2xl bg-white/80 backdrop-blur-xl ring-1 ring-slate-900/5 shadow-lg shadow-slate-900/5 px-4 py-2.5" data-id="element-52">
        <div className="flex items-center justify-center w-6 h-6 rounded-lg bg-indigo-600 text-white" data-id="element-53">
          <Sparkles className="w-3.5 h-3.5" data-id="element-54" />
        </div>
        <h1 className="font-semibold text-slate-800 tracking-tight text-sm" data-id="element-55">
          Logo Studio
        </h1>
      </div>

      {/* Floating actions pill */}
      <div className="absolute top-4 right-4 z-30 flex items-center gap-1.5 rounded-2xl bg-white/80 backdrop-blur-xl ring-1 ring-slate-900/5 shadow-lg shadow-slate-900/5 p-1.5" data-id="element-56">
        <button onClick={onUploadClick} className="text-sm font-medium text-slate-600 hover:text-slate-900 px-3 py-1.5 rounded-xl hover:bg-slate-900/5 transition-colors flex items-center gap-1.5" data-id="element-57">
          <Upload className="w-4 h-4" data-id="element-58" />
          New SVG
        </button>

        <button onClick={onExportClick} disabled={!hasImage} className="text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed px-4 py-1.5 rounded-xl transition-colors flex items-center gap-1.5 shadow-sm" data-id="element-59">
          <Download className="w-4 h-4" data-id="element-60" />
          Export
        </button>
      </div>
    </>;
}